import { atom } from "recoil"

export const constantsAtom = atom({
    key: "constantsAtom",
    default: []
})

export const constantTypesAtom = atom({
    key: "constantTypesAtom",
    default: []
})
